export const monitoring = {
    "activeMonitoring": {
        "pageTitle": "קמפיין אוטומטי חדש",
        "tabs": {
            "inMonitoring": "דירות בקמפיין",
            "withoutMonitoring": "דירות מחוץ לקמפיין"
        },
        "totalTenants": "סך כל הדיירים:",
        "labels": {
            "tenantValue": "סוג פנייה",
            "actionName": "שם הפעולה הנוכחית",
            "nextActionIn": "הפעולה הבאה בעוד",
            "nextActionName": "שם הפעולה הבאה",
            "sentAt": "נשלח ב-",
            "totalAmountMissing": "סכום כולל חסר",
            "days": "ימים",
            "hours": "שעות",
            "tenantEmail": "דוא\"ל לשוכר/ת",
            "tenantPhone": "הודעה לשוכר/ת",
            "ownerEmail": "דוא\"ל לבעלים",
            "ownerPhone": "הודעה לבעלים",
        },
        "actions": {
            "welcome": "ברוכים הבאים",
            "reminder": "תזכורת תשלום",
            "tenantEmail1": "הודעת מייל ראשונה לשוכר",
            "tenantEmail2": "הודעת דואר שנייה לשוכר",
            "tenantEmail3": "הודעת מייל שלישית לשוכר",
            "tenantEmail4": "הודעת מייל רביעית לשוכר",
            "tenantPhone1": "סמס מספר 1 לשוכר/ת",
            "tenantPhone2": "סמס מספר 2 לשוכר/ת",
            "tenantPhone3":  "סמס מספר 3 לשוכר/ת",
            "tenantPhone4":  "סמס מספר 4 לשוכר/ת",
            "ownerEmail1": "הודעת דוא\"ל ראשונה לבעלים",
            "ownerEmail2": "הודעת דוא\"ל שנייה לבעלים",
            "ownerEmail3": "הודעת דוא\"ל שלישית לבעלים",
            "ownerEmail4": "הודעת דוא\"ל רביעית לבעלים",
            "ownerPhone1": "סמס מספר 1 לבעלים",
            "ownerPhone2": "סמס מספר 2 לבעלים",
            "ownerPhone3": "סמס מספר 3 לבעלים",
            "ownerPhone4": "סמס מספר 4 לבעלים",
        },
        "btns": {
            "stopMonitoring": "הפסק/י מעקב על כל הבניינים",
            "stopMonitoringApartment": "הפסק/י מעקב דירה",
            "startMonitoring": "הכנס/י למעקב את כל הבניינים",
            "startMonitoringApartment": "הכנס/י דירה למעקב",
            "aptNotes": "הערות דירה",
            "startAll": "הפעל מעקב דירות",
            "stopAll": "הפסק מעקב דירות",
        },
        "successfullyStarted": "דירה הוכנסה לקמפיין בהצלחה",
        "successfullyStopped": "דירה הוצאה מהקמפיין בהצלחה",
        "tooManyOutOfCampaign": "שְׁגִיאָה. לא יכול להשאיר {{maxNum}} דירות מחוץ לקמפיין. אנא צור קשר עם שירות הלקוחות",
        "successfullyAllStarted": "כל ניטור הדירות הוחל בהצלחה",
        "successfullyAllStopped": "כל ניטור הדירות הופסק בהצלחה",
        "somethingWentWrong": "משהו השתבש",
    }
}
